import { ViewNotificationContent } from 'studio-components';

export enum NotificationContentFormApiErrorTypes {
  ServiceUnavailableError,
  NotFoundError,
}

export class NotificationContentFormApiError {
  constructor(public type: NotificationContentFormApiErrorTypes, public error: Error) {}
}

export enum FormMode {
  Edit = 'edit',
  Create = 'create',
  View = 'view',
}

export type NotificationContentProps<T> = {
  notificationContent: T;
};
export type NotificationContentLoadedProps = {
  notificationContent: ViewNotificationContent;
};
export type NotificationContentErroredProps = { error: NotificationContentFormApiError };
